import Main from "../../layouts/Main";
import Card from "../../components/Card";
import Tab from "../../components/Tab";
import Kasbon from "./Kasbon/List";
import Cicilan from "./Cicilan/List";

const KasbonApproval = () => {
  const data = [
    {
      name: "Kasbon",
      id: "#tab1",
      content: <Kasbon />,
    },
    {
      name: "Cicilan",
      id: "#tab2",
      content: <Cicilan />,
    },
  ];

  return (
    <Main title="Permintaan Kasbon & Cicilan">
      <Card col={"col-xl-12 col-lg-12"}>
        <Tab data={data} defaultId={data[0].id} defaultContent={data[0].content} />
      </Card>
    </Main>
  );
};

export default KasbonApproval;
